(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('LenderIntegrationPayload', LenderIntegrationPayload);

    LenderIntegrationPayload.$inject = ['$resource', 'DateUtils'];

    function LenderIntegrationPayload ($resource, DateUtils) {
        var resourceUrl =  'api/lender-integration-payloads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getGrid': {method: 'GET', url: 'api/lender-integration-payloads-grid', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastSendAttempt = DateUtils.convertDateTimeFromServer(data.lastSendAttempt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
